import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-auth-callback',
    standalone: true,
    imports: [],
    templateUrl: './auth-callback.html',
    styleUrl: './auth-callback.css',
})
export class AuthCallback implements OnInit {
    private route = inject(ActivatedRoute);
    private authService = inject(AuthService);

    loading = true;
    error: string | null = null;

    ngOnInit(): void {
        const code = this.route.snapshot.queryParamMap.get('code');
        const errorParam = this.route.snapshot.queryParamMap.get('error');
        const errorDescription = this.route.snapshot.queryParamMap.get('error_description');

        if (errorParam) {
            this.error = errorDescription || errorParam;
            this.loading = false;
            return;
        }

        if (!code) {
            this.error = 'Invalid callback — missing authorization code.';
            this.loading = false;
            return;
        }

        this.authService.handleCallback(code).catch((err) => {
            this.error = err?.message || 'Authentication failed';
            this.loading = false;
        });
    }
}
